import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { HiOutlineMenuAlt3, HiX } from "react-icons/hi";
import BrandLogo from "./BrandLogo";

const links = [
  { label: "Home", href: "#home" },
  { label: "Services", href: "#services" },
  { label: "Product", href: "#products" },
  { label: "About", href: "#about" },
  { label: "Career", href: "#career" },
  { label: "Blog", href: "#blog" },
  { label: "Contact", href: "#contact" },
];

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  const closeMenu = () => setIsOpen(false);

  return (
    <header className="fixed top-0 z-50 w-full border-b border-white/5 bg-[#070710]/70 backdrop-blur-lg">
      <nav className="section-shell flex h-20 items-center justify-between">
        <BrandLogo onClick={closeMenu} />

        <ul className="hidden items-center gap-4 lg:gap-6 md:flex">
          {links.map((link) => (
            <li key={link.label}>
              <a
                href={link.href}
                className="text-sm font-medium text-blue-100/85 transition hover:text-cyan-300"
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        <button
          type="button"
          onClick={() => setIsOpen((prev) => !prev)}
          className="glass inline-flex h-11 w-11 items-center justify-center rounded-lg text-cyan-200 transition hover:shadow-neon md:hidden"
          aria-label="Toggle menu"
        >
          {isOpen ? <HiX className="h-6 w-6" /> : <HiOutlineMenuAlt3 className="h-6 w-6" />}
        </button>
      </nav>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: -14 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -14 }}
            transition={{ duration: 0.25 }}
            className="mx-4 mb-3 rounded-xl border border-cyan-300/20 bg-[#090914]/90 p-4 shadow-glass backdrop-blur-xl md:hidden"
          >
            <ul className="flex flex-col gap-3">
              {links.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="block rounded-lg px-3 py-2 text-blue-100/90 transition hover:bg-white/5 hover:text-cyan-300"
                    onClick={closeMenu}
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}

export default Navbar;
